import angular from 'angular';
import ComponentsModule from '../components-module';
import template from './code-content-toolbar.html';
import Debug from 'ace-ui/ace-debug';
import _ from 'lodash';

const COMPONENT_NAME = 'codeContentToolbar';
const debug = new Debug (COMPONENT_NAME);

function setEnableds (state) {
  let isEditMode = state.mode === 'edit';

  state.preview.visible = state.isPreviewable;
  state.cancel.visible = isEditMode;
  state.close.visible = !isEditMode;
  state.edit.visible = !isEditMode && state.permissions && state.permissions.update;

  if (_.has(state, 'workflow.state.isEditableBy')) {
    state.edit.visible = state.edit.visible && state.workflow.state.isEditableBy;
  }

  state.save.visible = isEditMode;
  state.more.visible = true;
  state.copy.visible = true;
  state.publish.visible = !state.workflow && state.permissions && state.permissions.publish;
  state.publish.enabled = state.publish.visible && !state.isHidden && (state.isPublishable || isEditMode);

  state.isEditMode = isEditMode;

  state.preview.title = state.preview.visible
    ? 'content-toolbar.preview.title'
    : 'content-toolbar.preview.title.disabled';
}

angular.module (ComponentsModule)
  .component (COMPONENT_NAME, {
    template,

    bindings: {
      'cloneOf': '<',
      'copyInProgress': '<',
      'currentVersion': '<',
      'currentRevisionNumber': '<',
      'infoOpened': '<',
      'inProgress': '<',
      'isHidden': '<',
      'isPreviewable': '<',
      'isPublishable': '<',
      'isPublished': '<',
      'isThisPublished': '<',
      'metadata': '<',
      'mode': '<',
      'onAction': '&',
      'permissions': '<',
      'securityContexts': '<',
      'workflow': '<'
    },

    controller: function (KeyboardShortcutService, ContentEventService) {
      let unsubscribe = ContentEventService.subscribe('MAIN_WORKFLOW', (eventData) => {
        debug.log ('Processing workflow event.');
        debug.log ('[eventData, currentVersion, currentRevisionNumber]', [eventData, this.currentVersion, this.currentRevisionNumber]);
        if (eventData.current.versionId === this.currentVersion && eventData.current.revision !== this.currentRevisionNumber) {
          this.workflowChanged = true;
        }
      });

      this.info = {
        visible: true,
        enabled: true,
        shortcut: KeyboardShortcutService.inferUserKey('mod+i'),
        label: 'content-toolbar.info.label'
      };

      this.preview = {
        visible: true,
        enabled: true,
        title: 'content-toolbar.preview.title'
      };

      this.cancel = {
        visible: false,
        enabled: true,
        shortcut: KeyboardShortcutService.inferUserKey('escape'),
        label: 'content-toolbar.cancel.label'
      };

      this.close = {
        visible: false,
        enabled: true,
        shortcut: KeyboardShortcutService.inferUserKey('mod+u'),
        label: 'content-toolbar.close.label'
      };

      this.edit = {
        visible: false,
        enabled: true,
        shortcut: KeyboardShortcutService.inferUserKey('mod+e'),
        label: 'content-toolbar.edit.label'
      };

      this.save = {
        visible: false,
        enabled: true,
        shortcut: KeyboardShortcutService.inferUserKey('mod+s'),
        label: 'content-toolbar.save.label'
      };

      this.more = {
        visible: false,
        enabled: true,
        label: '...'
      };

      this.copy = {
        visible: false,
        enabled: true,
        label: 'content-toolbar.copy.label'
      };

      this.publish = {
        visible: false,
        enabled: false,
        label: 'content-toolbar.publish.label'
      };

      this.$onInit = function () {
        setEnableds(this);
      };

      this.$onDestroy = unsubscribe;

      this.$onChanges = function (changes) {
        if (changes.mode || changes.permissions || changes.isPublished || changes.isPublishable || changes.isThisPublished
          || changes.isPreviewable || changes.isHidden || changes.metadata
          || changes.workflow || changes.currentVersion || changes.securityContexts) {

          setEnableds(this);
        }
      };
    }
  });

export default COMPONENT_NAME;
